import React from "react";
import { Route } from "react-router-dom";

function NotFoundRoute(props) {
  return <Route>Not found</Route>;
}

export default NotFoundRoute;
